<script setup>
import ReportExportsForm from "@/components/ExternalApps/TransferApp/ReportExports/components/ReportExportsForm.vue";
import { objectToCron } from "@/components/ExternalApps/TransferApp/ReportExports/utility/helpers";
import { failLoadingEvent } from "@/components/ExternalApps/TransferApp/utility/errors";
import Project from "@/components/Settings/Projects/project";
import Presets from "@/components/Settings/Presets/presets";
import {
  addEventToLoadingQueue,
  removeEventFromLoadingQueue
} from "@/composables/useLoadingQueue";
import { UPDATE_SELECTED_PROJECT } from "@/core/services/store/switchArea.module";
import { useStore } from "@/core/services/store";
import { useReportExport } from "@/components/ExternalApps/TransferApp/ReportExports/composables/useReportExport";

const store = useStore();
const { formValues, reportId, currentExportProject } = useReportExport();

async function create() {
  addEventToLoadingQueue({ key: "create-report-export" });

  const formValuesCopy = Object.assign({}, formValues.value);
  let createdProject = {};
  formValuesCopy.cron = objectToCron({
    interval: formValuesCopy.interval,
    dayOfMonth: formValuesCopy.dayOfMonth,
    weekday: formValuesCopy.weekday,
    startHour: formValuesCopy.startHour,
    minuteOfHour: formValuesCopy.minuteOfHour
  });

  try {
    createdProject = await Project.store({
      name: `ReportsExports - ${formValuesCopy?.description ?? ""}`,
      preset_id: process.env.VUE_APP_TRANSFER_APP_REPORT_EXPORTS_PRESET_ID
    });

    // The backend answers failures during project creation with a 200 and an error field
    if (createdProject.data?.error) {
      throw createdProject.data.error;
    }

    await store.dispatch(UPDATE_SELECTED_PROJECT, createdProject.data);

    await Presets.store({
      name: "reportExport",
      label: "reportExport",
      type: "json",
      value: {
        ...formValuesCopy,
        reportId: reportId.value
      },
      project_id: createdProject.data.id
    });

    currentExportProject.value = {
      ...createdProject.data,
      report_id: reportId.value
    };
  } catch (e) {
    failLoadingEvent("create-report-export", e);

    return;
  }

  removeEventFromLoadingQueue({
    key: "create-report-export",
    type: "success",
    prefix: "reportExports",
    name: "saveFinished"
  });
}
</script>

<template>
  <div class="h-100">
    <ReportExportsForm
      :save-button-label="$t('reportExports.create')"
      mode="create"
      @save="create"
    />
  </div>
</template>

<style scoped lang="scss"></style>
